export default __webpack_public_path__ + "static/media/banner-bg.7b3b100f.jpg";